Blackprint.CodeType = {
	Init: '__Init',
	Callback: '__Callback',
	Wrapper: '__Wrapper',
	NotWrapped: '__NotWrapped',
};